import "./App.scss"
import Modal from "./components/Modal/Modal";

function App() {


  return (
    <>
      <Modal>
      </Modal>
    </>
  );
}

export default App;
